import { gql } from "@apollo/client";

export const markFeatureAnnouncementSeenMutation = gql`
  mutation MarkFeatureAnnouncementSeen($announcementId: String!, $tourCompleted: Boolean) {
    markFeatureAnnouncementSeen(announcementId: $announcementId, tourCompleted: $tourCompleted) {
      message
    }
  }
`;
